import React from "react"
import { graphql } from "gatsby"
import { useMainOfficeNumber } from "hooks/useMainOfficeNumber"
import { useStrapiButtons } from "hooks/useStrapiButtons"
import { ButtonParser } from "components/button/ButtonParser"
import type { ButtonElements, ReusableButtonGroup } from "_types/Button"
import type { StrapiImageItem } from "_types/AssetsImage"
import "./cta-banner.module.scss"

interface CTABannerProps {
  // eyebrow_text: string | null
  background_image: StrapiImageItem
  buttons: ButtonElements[]
  cta_description: string | null
  heading: string | null
  reusable_button_group: ReusableButtonGroup
}

export const CTABanner = ({
  // eyebrow_text,
  background_image,
  buttons,
  cta_description,
  heading,
  reusable_button_group,
}: CTABannerProps) => {
  const { mainOfficeNumber } = useMainOfficeNumber({})
  const strapiButtons = useStrapiButtons(buttons, reusable_button_group)

  const noImageClass = !background_image?.url
    ? "CTA__buttonContainerNoImage"
    : ""

  return (
    <div className="CTA">
      <div className="fr-container fr-container--large">
        <div className="CTA__wrapper">
          {/* {eyebrow_text && <h4>{eyebrow_text}</h4>} */}
          {heading && <h2>{heading}</h2>}
          {mainOfficeNumber && (
            <a href={`tel:${mainOfficeNumber}`} className="CTA__phone">
              {mainOfficeNumber}
            </a>
          )}

          <div className="CTA__description">
            {cta_description && <p>{cta_description}</p>}
          </div>

          {!!strapiButtons?.length && (
            <div
              className={`CTA__buttonContainer CTA__button ${noImageClass} content-block-buttons`}
            >
              <ButtonParser
                buttons={strapiButtons}
                navigationColorVariantSolid="solid-accent"
                ctaColorVariantSolid="solid-accent"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export const strapiQuery = graphql`
  fragment StrapiCTABannerFragment on STRAPI__COMPONENT_CONTENT_BLOCK_CTA_BANNER {
    strapi_component
    id
    cta_description
    eyebrow_text
    heading
    sub_heading
    background_image {
      ...StrapiBaseImageFragment
      localFile {
        childImageSharp {
          gatsbyImageData(
            avifOptions: { lossless: true, speed: 10, quality: 30 }
            webpOptions: { quality: 7 }
            formats: [AUTO, AVIF, WEBP]
            placeholder: BLURRED
            breakpoints: [1024, 1366, 1920, 2560]
          )
        }
        publicURL
      }
    }
    buttons {
      ...StrapiButtonFragment
    }
    reusable_button_group {
      ...StrapiReusableButtonFragment
    }
  }
`
